import { apiDownload, apiRequest } from './apiClient';
import { getStudentGrades } from './gradeService';

export { getStudentGrades };

export async function verifyParentPassword(password) {
  const response = await apiRequest('/student/verify-parent-password', {
    method: 'POST',
    body: { password },
  });

  return response.data?.valid === true;
}

export async function getStudentAttendance(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classSubjectId) {
    params.set('classSubjectId', filters.classSubjectId);
  }

  if (filters.startDate) {
    params.set('startDate', filters.startDate);
  }

  if (filters.endDate) {
    params.set('endDate', filters.endDate);
  }

  const query = params.toString();
  const response = await apiRequest(`/student/attendance${query ? `?${query}` : ''}`);

  return response.data || {
    startDate: null,
    endDate: null,
    totalRecords: 0,
    statusCounts: [],
    records: [],
  };
}

export async function exportStudentAttendance(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classSubjectId) {
    params.set('classSubjectId', filters.classSubjectId);
  }

  if (filters.startDate) {
    params.set('startDate', filters.startDate);
  }

  if (filters.endDate) {
    params.set('endDate', filters.endDate);
  }

  const query = params.toString();
  await apiDownload(`/student/attendance/export${query ? `?${query}` : ''}`, {
    fallbackFilename: 'attendance.xlsx',
  });
}
